export default "__VITE_ASSET__2d169c2f__"